import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AtlasConfigService } from '../../../../../core/src';
import { Observable } from 'rxjs';
import { AccountsFormSettingsComponent } from './accounts-form-settings.component';

@Component({
  selector: 'atlas-notification-accounts-form',
  templateUrl: './accounts-form.component.html',
  styleUrls: ['./accounts-form.component.scss'],
  standalone: false,
})
export class AccountsFormComponent {
  @Input() partnerId: string;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onError: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(AccountsFormSettingsComponent, { static: true }) form: AccountsFormSettingsComponent;

  accountGroupId$: Observable<string> = this.cfgService.accountId$;

  constructor(private cfgService: AtlasConfigService) {}

  get error(): boolean {
    return this.form.error;
  }

  get saving(): boolean {
    return this.form.saving;
  }

  public dirty(): boolean {
    return this.form.dirty();
  }

  public reset(): void {
    this.form.reset();
  }

  public save(): void {
    this.form.save();
  }
}
